import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "@fortawesome/fontawesome-free/css/all.min.css";
import defaultAvatar from "../images/download.jpg";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

function Investor() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [items, setItems] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showCamera, setShowCamera] = useState(false);
  const [stream, setStream] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  
  const baseURL = process.env.REACT_APP_BASE_URL;

  console.log("Base URL:", baseURL);
  const [touched, setTouched] = useState({
    contactno: false,
    aadharno: false,
    acno: false,
    acname: false,
    address: false,
    statuss: false,
  });
  const [formData, setFormData] = useState({
    image: "",
    acno: "",
    acname: "",
    aadharno: "",
    contactno: "",
    statuss: "",
    address: "",
  });

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      if (!isEditMode) {
        const emptyData = {
          image: "",
          aadharno: "",
          acno: "",
          acname: "",
          contactno: "",
          statuss: "",
          address: "",
        };
        setTouched({
          contactno: false,
          aadharno: false,
          acno: false,
          acname: false,
          address: false,
          statuss: false,
        });
        setFormData(emptyData);

        const newErrors = {};
        for (const field in emptyData) {
          newErrors[field] = validateField(field, emptyData[field]);
        }
        setErrors(newErrors);
        setSelectedImage(null);
      }
    }

    setIsSubmitted(false);
  };

  const openCamera = async () => {
    setShowCamera(true);
  
    // ✅ Stop any previously active stream
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }
  
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
        audio: false,
      });
  
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
  
        videoRef.current.onloadedmetadata = () => {
          videoRef.current
            .play()
            .then(() => {
              console.log("Video is playing");
            })
            .catch((err) => {
              console.error("Error playing video:", err);
            });
        };
      }
  
      setStream(mediaStream);
    } catch (error) {
      console.error("Error accessing camera:", error);
      alert("Could not access the camera.");
    }
  };
  

 const closeCamera = () => {
  if (stream) {
    stream.getTracks().forEach((track) => track.stop());
    setStream(null); // Clear the state
  }

  if (videoRef.current) {
    videoRef.current.srcObject = null;
  }

  setShowCamera(false);
};
const captureImage = () => {
  const canvas = canvasRef.current;
  const video = videoRef.current;

  if (canvas && video) {
    const context = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob((blob) => {
      if (blob) {
        const timestamp = Date.now();
        const fileName = `investor_${timestamp}.jpg`;
        const imageFile = new File([blob], fileName, { type: "image/jpeg" });

        const imageUrl = URL.createObjectURL(imageFile);

        setSelectedImage(imageFile);

        setFormData((prev) => ({
          ...prev,
          image: fileName,       
          imageURL: imageUrl,  
        }));

        closeCamera();
      }
    }, "image/jpeg");
  }

  setShowCamera(false);
};

  const validateField = (name, value) => {
    let error = "";
  
    
    if ((name === "acname" || name === "acno" || name === "contactno") && !value) {
      return "Required";
    }
  
    
    if (name === "contactno" && value) {
      if (!/^\d{10}$/.test(value)) {
        error = "Contact number must be 10 digits";
      } else if (!/^[6-9]/.test(value)) {
        error = "Contact number must start with 9, 8, 7, or 6";
      }
    }
  
   
    if (name === "aadharno" && value) {
      if (!/^\d{4}-\d{4}-\d{4}$/.test(value)) {
        error = "Aadhar number must be in the format xxxx-xxxx-xxxx";
      }
    }
  
    if (name === "acno" && value) {
      if (!/^[a-zA-Z0-9]+$/.test(value)) {
        error = "Account number must contain only letters and numbers";
      }
    }
  
    return error;
  };
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let formattedValue = value;

    if (name === "aadharno") {
      formattedValue = formattedValue.replace(/(\d{4})(?=\d)/g, "$1-");     }

    setFormData((prevData) => ({
      ...prevData,
      [name]: formattedValue,
    }));

    setTouched((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, formattedValue),
    }));
  };

  const updateData = async (id) => {
    const item = items.find((item) => item.id === id);
    if (!item) return;
  
    let imageURL = null;

    
  
    const isValidImage =
      item.image &&
      typeof item.image === "string" &&
      item.image !== "blob" &&
      item.image !== "[object Object]" &&
      item.image !== "null";
  
    if (isValidImage) {
      try {
        const accessToken = sessionStorage.getItem("access_token");
  
        const response = await axios.get(
          `${baseURL}/images/InvestorImages/${item.image}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            responseType: "blob",
          }
        );
  
        imageURL = URL.createObjectURL(response.data);
      } catch (error) {
        console.error("Error fetching image:", error);
  
        
        imageURL = `${baseURL}/images/InvestorImages/${item.image}`;
      }
    }
  
    const newFormData = {
      id: item.id,
      image: item.image || "",
      imageURL: imageURL,
      aadharno: item.aadharno || "",
      acname: item.acname || "",
      acno: item.acno || "",
      contactno: item.contactno || "",
      statuss: item.statuss || "",
      address: item.address || "",
    };
  
    setFormData(newFormData);
    console.log("Populated formData for update:", newFormData);
    console.log("Updating data for customer", item);
  
    setIsEditMode(true);
    setSelectedImage(null);
    setIsModalOpen(true);
  };
  

  
  const handleEdit = async () => {
    console.log("Form Data before update:", formData);
    setIsSubmitted(true);
    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      return;
    }
    let isAadharDuplicate = false;
    if (formData.aadharno) {
      isAadharDuplicate = items.some(
        (item) => item.aadharno === formData.aadharno && item.id !== formData.id
      );
    }
    if (isAadharDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Aadhaar number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    let isAcnoDuplicate = false;

    if (formData.acno) {
      isAcnoDuplicate = items.some(
        (item) => item.acno === formData.acno && item.id !== formData.id
      );
    }
    if (isAcnoDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Account number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    let isContactNoDuplicate = false;
    if (formData.contactno) {
      isContactNoDuplicate = items.some(
        (item) =>
          item.contactno === formData.contactno && item.id !== formData.id
      );
    }
    if (isContactNoDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Contact number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    const data = new FormData();
    if (selectedImage) {
      data.append("image", selectedImage);
      console.log(selectedImage);
      console.log("Image appended:", selectedImage);
    }

    data.append("id", formData.id);
    data.append("aadharno", formData.aadharno);
    data.append("acname", formData.acname);
    data.append("acno", formData.acno);
    data.append("statuss", formData.statuss);
    data.append("address", formData.address);
    data.append("contactno", formData.contactno);

    console.log("FormData being sent:", Array.from(data.entries()));

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.put(`${baseURL}/updateInvestor`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`, 
        },
      });

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: "Investor updated successfully!",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchItems();
        toggleModal();
        setIsEditMode(false);
      } else {
        console.error("Error updating investor:", response.data);
      }
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const handleSubmit = async () => {
    setTouched({
      contactno: true,
      aadharno: true,
      acno: true,
      acname: true,
      address: true,
      statuss: true,
    });
    setIsSubmitted(true);
    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      return;
    }
    let isAadharDuplicate = false;
    if (formData.aadharno) {
      isAadharDuplicate = items.some(
        (item) => item.aadharno === formData.aadharno
      );
    }
    if (isAadharDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Aadhaar number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    let isAcNoDuplicate = false;
    if (formData.acno) {
      isAcNoDuplicate = items.some((item) => item.acno === formData.acno);
    }
    if (isAcNoDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Account number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    let isContactNoDuplicate = false;
    if (formData.contactno) {
      isContactNoDuplicate = items.some(
        (item) => item.contactno === formData.contactno
      );
    }
    if (isContactNoDuplicate) {
      Swal.fire({
        icon: "error",
        text: "Contact number already exists!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    const data = new FormData();
    if (selectedImage) {
      data.append("image", selectedImage);
      console.log("Selected Image:", selectedImage);
    } else {
      const response = await fetch(defaultAvatar);

      const blob = await response.blob();
      const defaultFile = new File([blob], "default-avatar.jpg", {
        type: blob.type,
      });
      data.append("image", defaultFile);
      console.log("Default Avatar Image:", defaultFile);
    }

    data.append("id", formData.id);
    data.append("aadharno", formData.aadharno);
    data.append("acname", formData.acname);
    data.append("acno", formData.acno);
    data.append("statuss", formData.statuss);
    data.append("address", formData.address);
    data.append("contactno", formData.contactno);

    const accessToken = sessionStorage.getItem("access_token");
    try {
      const response = await axios.post(`${baseURL}/insertInvestor`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      Swal.fire({
        icon: "success",
        text: "Investor added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      toggleModal();
      fetchItems();
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      setFormData({
        ...formData,
        image: file.name,
      });
    }
  };

  useEffect(() => {
    if (isEditMode) {
      setSelectedImage(null);
    }
  }, [isEditMode]);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    setIsLoading(true);
    try {
      const accessToken = sessionStorage.getItem("access_token");

      // Fetch data from the backend, including image names
      const response = await axios.get(`${baseURL}/getAllInvestor`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const itemsWithImages = await Promise.all(
        response.data.map(async (item) => {
          if (item.image) {
            try {
              // Fetch the image as a blob
              const imageResponse = await axios.get(
                `${baseURL}/images/InvestorImages/${item.image}`,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`,
                  },
                  responseType: "blob",
                }
              );
              // Create a blob URL for the image
              const imageURL = URL.createObjectURL(imageResponse.data);
              return { ...item, imageURL }; // Attach the image URL to the item
            } catch (imageError) {
              console.error("Error fetching image:", imageError);
              return { ...item, imageURL: null }; // Handle missing or failed images
            }
          } else {
            return { ...item, imageURL: null }; // Handle items without images
          }
        })
      );

      setItems(itemsWithImages); // Update state with items and their corresponding image URLs
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem(item.id);
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The user has been deleted.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };

  const deleteItem = async (id) => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.delete(`${baseURL}/deleteInvestor`, {
        data: { id: id },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 200) {
        fetchItems();
      } else {
        Swal.fire({
          icon: "error",
          title: "Deletion Failed",

          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    if (isEditMode) {
      setSelectedImage(null);
    }
  }, [isEditMode]);

  const filteredItems = items.filter(
    (item) =>
      item.acname.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.acno.includes(searchQuery) ||
      item.contactno.includes(searchQuery) ||
      item.aadharno.includes(searchQuery)
  );

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="bg-gray-100 flex flex-col w-full">
      <main className="flex-grow p-6 w-full">
        <h2 className="text-3xl font-bold text-center mt-5">Investor</h2>

        {/* Table */}
        <div className="mt-6 bg-white shadow rounded-lg p-4 ml-0 sm:ml-0 md:ml-28 lg:ml-64">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0 mb-4">
            <div className="flex items-center space-x-2">
              <select
                className="border border-gray-300 rounded p-1"
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                value={itemsPerPage}
              >
                <option className="md:text-xs" value="10">
                  10
                </option>
                <option className="md:text-xs" value="25">
                  25
                </option>
                <option className="md:text-xs" value="50">
                  50
                </option>
              </select>
              <span>entries</span>
            </div>

            <div className="flex items-center space-x-4 overflow-y-auto">
              <button
                onClick={() => {
                  setIsEditMode(false);
                  toggleModal();
                }}
                className="bg-green-500 text-white px-4 py-2 rounded w-full sm:w-auto"
              >
                Add Investor
              </button>
              {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="relative w-full sm:w-full md:w-1/2 max-h-[70vh] overflow-y-auto bg-white rounded-lg p-4 top-12 sm:top-16 md:top-24">
                    <div className="flex justify-between items-center mb-4">
                      <h2 className="text-lg md:text-xl font-semibold">
                        {isEditMode ? "Update Investor" : "Add Investor"}
                      </h2>
                      <button
                        onClick={() => {
                          toggleModal();
                          setIsEditMode(false);
                        }}
                        className="text-gray-600 text-2xl"
                      >
                        &times;
                      </button>
                    </div>
                    <form className="space-y-4">
                      <div className="flex flex-col items-center mb-6">
                        <label className="relative cursor-pointer">
                          <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center">
                            <img
                              src={
                                selectedImage
                                  ? URL.createObjectURL(selectedImage)
                                  : formData.imageURL 
                                  ? formData.imageURL
                                  : defaultAvatar 
                              }
                              alt="Profile Preview"
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="hidden"
                          />
                        </label>
                        <span
                          className="text-sm text-gray-600
           mt-2"
                        >
                          Photo
                        </span>
                        <div className="mt-2 flex flex-col items-center">
                          <button
                            type="button"
                            onClick={openCamera}
                            className="text-blue-500 underline text-sm"
                          >
                            Use Camera
                          </button>
                        </div>

                        {showCamera && (
                          <div className="my-4">
                            <video
                              ref={videoRef}
                              autoPlay
                              playsInline
                              className="w-full rounded shadow"
                            />
                            <canvas ref={canvasRef} className="hidden" />
                            <div className="flex justify-end space-x-2 mt-2">
                             
                              <button
                                onClick={closeCamera}
                                type="button"
                                className="bg-red-500 text-white px-3 py-1 rounded"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={captureImage}
                                type="button"
                                className="bg-green-500 text-white px-3 py-1 rounded"
                              >
                                Capture
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-gray-600">
                            Account Number{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="acno"
                            value={formData.acno || ""}
                            minLength={10}
                            maxLength={16}
                            onChange={handleInputChange}
                            placeholder="Enter bank account number"
                            className={`border p-2 w-full placeholder:text-sm ${
                              errors.acno && touched.acno
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.acno && touched.acno && (
                            <span className="text-red-500 text-sm">
                              {errors.acno}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Investor Name{" "}
                            <span className="text-red-500">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            name="acname"
                            value={formData.acname || ""}
                            onChange={handleInputChange}
                            className={`border p-2 w-full ${
                              errors.acname && touched.acname
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.acname && touched.acname && (
                            <span className="text-red-500 text-sm placeholder:text-sm">
                              {errors.acname}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Aadhar No
                          </label>
                          <input
                            type="text"
                            name="aadharno"
                            value={formData.aadharno || ""}
                            onChange={handleInputChange}
                            placeholder="Enter aadhar no. in xxxx-xxxx-xxxx format"
                            className={`border p-2 w-full  placeholder:text-sm ${
                              errors.aadharno && touched.aadharno
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.aadharno && touched.aadharno && (
                            <span className="text-red-500 text-sm">
                              {errors.aadharno}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Contact Number{" "}
                            <span className="text-red-500">*</span>{" "}
                          </label>
                          <input
                            type="text"
                            name="contactno"
                            value={formData.contactno || ""}
                            maxLength={10}
                            onChange={handleInputChange}
                            placeholder="Enter 10 digit mobile number name"
                            className={`border p-2 w-full placeholder:text-sm ${
                              errors.contactno && touched.contactno
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.contactno && touched.contactno && (
                            <span className="text-red-500 text-sm">
                              {errors.contactno}
                            </span>
                          )}
                        </div>
                        {isEditMode && (
                          <div>
                            <label className="block text-gray-600">
                              Status
                            </label>
                            <select
                              name="statuss"
                              value={formData.statuss || ""}
                              onChange={handleInputChange}
                              className="border p-2 w-full border-gray-300"
                            >
                              <option>Mark the status</option>
                              <option>Active</option>
                              <option>Inactive</option>
                            </select>
                          </div>
                        )}
                      </div>
                      <div>
                        <label className="block text-gray-600">Address</label>
                        <textarea
                          name="address"
                          value={formData.address || ""}
                          onChange={handleInputChange}
                          className={`border p-2 w-full border-gray-300
                          `}
                          rows="3"
                        ></textarea>
                      </div>
                      <div className="flex justify-end space-x-2 mt-4">
                        <button
                          type="button"
                          onClick={() => {
                            toggleModal();
                            setIsEditMode(false);
                          }}
                          className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                        >
                          Close
                        </button>
                        <button
                          onClick={() => {
                            if (isEditMode) {
                              handleEdit();
                            } else {
                              handleSubmit();
                              setIsEditMode(false);
                            }
                          }}
                          type="button"
                          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                        >
                          {isEditMode ? "Update" : "Submit"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="flex items-center space-x-2">
                <input
                  type="text"
                  placeholder="Search"
                  className="border border-gray-300 rounded p-1  w-full sm:w-auto"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col h-screen">
            <div className="overflow-x-auto">
              <table className="w-full text-left   border-collapse text-sm sm:text-xs md:text-sm lg:text-base">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2">Id</th>
                    <th className="p-2">Photo</th>
                    <th className="p-2">Account No</th>
                    <th className="p-2">Account Name</th>
                    <th className="p-2">Aadhar No</th>
                    <th className="p-2">Contact No</th>
                    <th className="p-2">Status</th>
                    <th className="p-2">Address</th>
                    <th className="p-2">Options</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    // Render a loading message or spinner while data is being fetched
                    <tr>
                      <td colSpan="9" className="text-center p-4">
                        Loading...
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    // Render table rows when data has been loaded and `currentItems` is not empty
                    currentItems.map((item) => (
                      <tr key={item.id} className="border-b">
                        <td className="p-2">{item.id}</td>
                        <td className="p-2">
                          <img
                            src={item.imageURL ? item.imageURL : defaultAvatar}
                            alt="User Avatar"
                            className="w-8 h-8 rounded-full"
                          />
                        </td>
                        <td className="p-2">{item.acno || "--"}</td>
                        <td className="p-2">{item.acname || "--"}</td>
                        <td className="p-2">{item.aadharno || "--"}</td>
                        <td className="p-2">{item.contactno || "--"}</td>
                        <td className="p-2">{item.statuss || "--"}</td>
                        <td className="p-2">{item.address || "--"}</td>
                        <td className="p-2 space-x-3">
                          <button
                            onClick={() => updateData(item.id)}
                            className="text-blue-500"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            onClick={() => handleDelete(item)}
                            className="text-red-500"
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    // Handle the case where no data is available
                    <tr>
                      <td colSpan="9" className="text-center p-4">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination Controls */}
              <div className="flex justify-between items-center mt-4">
                <p>
                  Showing {indexOfFirstItem + 1} to{" "}
                  {indexOfLastItem > items.length
                    ? items.length
                    : indexOfLastItem}{" "}
                  of {items.length} entries
                </p>
                <div className="flex space-x-2">
                  <button
                    className="border px-2 py-1 rounded"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                  {[...Array(totalPages).keys()].map((num) => (
                    <button
                      key={num}
                      className={`border px-2 py-1 rounded ${
                        currentPage === num + 1 ? "bg-blue-500 text-white" : ""
                      }`}
                      onClick={() => handlePageChange(num + 1)}
                    >
                      {num + 1}
                    </button>
                  ))}
                  <button
                    className="border px-2 py-1 rounded"
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Investor;
